import { render, staticRenderFns } from "./SimpleStatusBlock.vue?vue&type=template&id=13e4f2c2&scoped=true&"
import script from "./SimpleStatusBlock.vue?vue&type=script&lang=js&"
export * from "./SimpleStatusBlock.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStatusBlock.vue?vue&type=style&index=0&id=13e4f2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4f2c2",
  null
  
)

export default component.exports